import pickUpMapDeanMartin from '../images/pickupmap-dean-martin.jpg';
import pickUpMapPhoenix from '../images/pickup-map-phoenix.png';
import pickUpMapNorthLasVegas from '../images/pickupmap-north-las-vegas.jpg';

const PICKUP_LOCATIONS = {
  5: pickUpMapNorthLasVegas,
  14: pickUpMapDeanMartin,
  33: pickUpMapPhoenix,
};

const STATES = [
  'AL',
  'AK',
  'AS',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FM',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MH',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'MP',
  'OH',
  'OK',
  'OR',
  'PW',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VI',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

const DAYS_BACK = 14;

export { STATES, DAYS_BACK, PICKUP_LOCATIONS };
